import { useGetFormalOffers } from '@api/lendingAPI/lapiHooks';
import IwRedirect from '@iwRouter/IwRedirect';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { SelectedOfferView } from './SelectedOfferView';
import { buildLocationWithSearch } from '../../../drawDown/DrawDownHelper';
import MainContentPending from '../../../pageStructure/mainContentPending';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    validateAndStartDrawdown: (
        selectedOfferId: string,
        drawdownAmount: number
    ) => {
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            //@ts-ignore
            location: buildLocationWithSearch({
                pathname: '/funding-requirements/',
                offerId: selectedOfferId,
                amount: drawdownAmount
            })
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const AccessUserApprovedView = ({
    validateAndStartDrawdown
}: PropsFromRedux) => {
    const { formalOffers, loadingFormalOffers } = useGetFormalOffers();

    const selectedFormalOffer = _.maxBy(formalOffers, (offer) =>
        offer.selected_by_customer_at
            ? new Date(offer.selected_by_customer_at).getTime()
            : -Infinity
    );

    if (loadingFormalOffers) {
        return (
            <MainContentPending data-testid="access-user-approved-view-loading" />
        );
    }

    if (!selectedFormalOffer) {
        return <IwRedirect pathname="/history" />;
    }
    return (
        <SelectedOfferView
            selectedFormalOffer={selectedFormalOffer}
            validateAndStartDrawdown={validateAndStartDrawdown}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(AccessUserApprovedView);
